var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"popup"},[_c('div',{staticClass:"popup-content"},[_vm._v("\n    "+_vm._s(_vm.content)+"\n  ")]),_vm._v(" "),_c('button',{staticClass:"close-button",on:{"click":_vm.closePopup}},[_vm._v("關閉")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67d86883","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/language-tw-loader!./src/components/Popup.vue
// module id = null
// module chunks = 